require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-everything-you-need-to-know-about-international-tax-and-vat-legislation.json") })
        }
      }, "path---blog-everything-you-need-to-know-about-international-tax-and-vat-legislation");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-everything-you-need-to-know-about-international-tax-and-vat-legislation!./.cache/json/blog-everything-you-need-to-know-about-international-tax-and-vat-legislation.json
// module id = 441
// module chunks = 231608221292675